import router from '@/router'
import {commonLogin, getUserInfo, getMySignupList} from '@/http/api'

export default {
  namespaced: true,
  state: {
    tokenIssuer: '',
    token: '',
    clientId: '',
    mobile: '',
    userRole: '',
    applyList: []
  },
  getters: {
    isLogin: state => !!state.token,
    isAdmin: state => state.userRole === 1
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_TOKENISSUER: (state, data) => {
      state.tokenIssuer = data
    },
    SET_CLIENTID: (state, clientId) => {
      state.clientId = clientId
    },
    SET_MOBILE: (state, mobile) => {
      state.mobile = mobile
    },
    SET_USERROLE: (state, userRole) => {
      state.userRole = userRole
    },
    SET_APPLYLIST: (state, list) => {
      state.applyList = [...list]
    }
  },
  actions: {
    commonLogin({state, commit, dispatch}, params) {
      return new Promise(resolve => {
        commonLogin({
          providerSys: state.tokenIssuer,
          loginType: 2,
          loginName: params.loginName,
          checkCode: params.checkCode
        }).then(async res => {
          if (res.result === 'SUCCEED') {
            commit('SET_TOKEN', res.data.token)
            commit('SET_CLIENTID', res.data.userId)
            commit('SET_MOBILE', res.data.mobile)
            // 获取 userRole
            dispatch('getUserInfo')
            // 获取通知列表
            dispatch('notice/getAdvertPush', null, {root: true})
            dispatch('notice/getAdvertClickList', null, {root: true})
            resolve()
          }
        })
      })
    },
    updateUserInfo({commit, dispatch}, params) {
      return new Promise(resolve => {
        commit('SET_TOKENISSUER', params.tokenIssuer)
        commit('SET_TOKEN', params.token)
        commit('SET_CLIENTID', params.clientId)
        commit('SET_MOBILE', params.mobile)
        // // 获取 userRole
        // params.token && dispatch('getUserInfo')
        // 获取通知列表
        params.token && dispatch('notice/getAdvertPush', null, {root: true})
        params.token && dispatch('notice/getAdvertClickList', null, {root: true})
        resolve()
      })
    },
    getUserInfo({state, commit}) {
      return new Promise(resolve => {
        getUserInfo({wechatId: state.clientId}).then(res => {
          if (res.result === 'SUCCEED') {
            commit('SET_USERROLE', res.data.userRole)
            resolve()
          }
        })
      })
    },
    logout({commit}) {
      commit('SET_TOKENISSUER', '')
      commit('SET_TOKEN', '')
      commit('SET_CLIENTID', '')
      commit('SET_MOBILE', '')
      commit('SET_USERROLE', '')
      commit('SET_APPLYLIST', [])
      router.replace({path: '/annualMeeting/index'})
    },
    getMySignupList({state, commit, rootGetters}) {
      return new Promise(resolve => {
        getMySignupList({
          activityId: rootGetters['base/activityId'],
          clientId: state.clientId,
          clientPhone: state.mobile
        }).then(res => {
          if (res.result === 'SUCCEED') {
            commit('SET_APPLYLIST', res.data)
            resolve()
          }
        })
      })
    }
  }
}
